import React from 'react';

type Link = {
  label: string;
  href: string;
  note?: string;
};

const sportsLinks: Link[] = [
  {
    label: 'Pacific Tigers Baseball – Roster',
    href: 'https://pacifictigers.com/sports/baseball/roster/nate-verlin/661',
    note: 'My University of the Pacific player profile.',
  },
  {
    label: 'Baseball-Reference – Nate Verlin',
    href: 'https://www.baseball-reference.com/register/player.fcgi?id=verlin000nat',
    note: 'Career stats and historical record.',
  },
  {
    label: 'MLB Statcast Search',
    href: 'https://baseballsavant.mlb.com/',
  },
];

const SportsFeedWidget: React.FC = () => {
  return (
    <div className="terminal-panel flex flex-col justify-between rounded-2xl border border-slate-800/80 p-4 text-xs text-slate-200">
      <div>
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Sports & baseball</span>
          <span className="rounded-full bg-slate-800 px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.16em] text-slate-300">
            Context
          </span>
        </div>
        <p className="mt-2 text-[11px] text-slate-400">
          A few links that connect my playing background to the baseball and analytics ecosystem I now build software for.
        </p>
      </div>
      <ul className="mt-3 space-y-2">
        {sportsLinks.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className="block rounded-lg border border-slate-800/80 bg-slate-900/80 px-3 py-2 text-[11px] text-slate-100 transition hover:border-emerald-400/70 hover:bg-slate-900"
            >
              <div className="flex items-center justify-between">
                <span className="truncate">{link.label}</span>
                <span className="ml-2 text-[13px] text-slate-500">↗</span>
              </div>
              {link.note && <p className="mt-1 text-[10px] text-slate-400">{link.note}</p>}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SportsFeedWidget;

